module.exports = __webpack_public_path__ + "static/media/语音合成（文本转语音）).69b7956f.png";